import React, { useContext } from "react";
import { CardBody, Col, Label, Row } from "reactstrap";
import { ViewOfferContext } from "./context";

const ViewOfferGrantsRecurring = ({ grantsRecurringList }) => {
  const { sectionRefs } = useContext(ViewOfferContext);
  return (
    <CardBody>
      {grantsRecurringList?.length === 0 ? (
        <div className="text-center">No Grants</div>
      ) : (
        grantsRecurringList?.map((grant, index) => {
          const grantRef = sectionRefs.current[`recurringGrants${index + 1}`];
          return (
            <div
              key={index}
              className="border border-opacity-50 rounded-0 mb-3"
              ref={grantRef}
            >
              <Row
                className={`mb-3 px-3 pt-3 ${
                  index === grantsRecurringList?.length - 1
                    ? ""
                    : "border-bottom"
                }`}
                key={index}
              >
                <Col
                  xs={12}
                  className="d-flex justify-content-between align-items-center pb-4"
                >
                  <h3 className="card-title mb-0">
                    Grant {index > 0 ? index + 1 : ""}
                  </h3>
                </Col>

                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label
                    htmlFor={`recurringGrants[${index}].recurringFrequency`}
                    className="fw-bold"
                  >
                    Recurring Frequency
                  </Label>
                  <p>
                    {grant?.recurringFrequency
                      ? grant?.recurringFrequency?.label
                      : "-"}
                  </p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label
                    htmlFor={`recurringGrants[${index}].recurringFrequencyUnit`}
                    className="fw-bold"
                  >
                    Recurring Frequency Unit
                  </Label>
                  <p>
                    {grant?.recurringFrequencyUnit
                      ? grant?.recurringFrequencyUnit
                      : "-"}
                  </p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label
                    for={`recurringGrants[${index}].cycleAlignment`}
                    className="fw-bold"
                  >
                    Cycle Alignment
                  </Label>
                  <p>
                    {grant?.cycleAlignment ? grant?.cycleAlignment?.label : "-"}
                  </p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label
                    htmlFor={`recurringGrants[${index}].resourceType`}
                    className="fw-bold"
                  >
                    Resource Type
                  </Label>
                  <p>
                    {grant?.resourceType ? grant?.resourceType?.label : "-"}
                  </p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label
                    htmlFor={`recurringGrants[${index}].resourceValue`}
                    className="fw-bold"
                  >
                    Resource Value
                  </Label>
                  <p>{grant?.resourceValue ? grant?.resourceValue : "-"}</p>
                </Col>

                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label className="fw-bold">Type of Resource</Label>
                  <p>{"Non-Currency"}</p>
                </Col>
                {grant?.infinite && (
                  <Col xs={12} md={6} lg={4} xxl={3}>
                    <Label
                      htmlFor={`recurringGrants[${index}].infinite`}
                      className="fw-bold"
                    >
                      Infinite
                    </Label>
                    <p>{grant?.infinite ? grant?.infinite?.label : "-"}</p>
                  </Col>
                )}
                {grant?.ceiling ? (
                  <Col xs={12} md={6} lg={4} xxl={3}>
                    <Label
                      htmlFor={`recurringGrants[${index}].ceiling`}
                      className="fw-bold"
                    >
                      Ceiling
                    </Label>
                    <p>{grant?.ceiling ? grant?.ceiling : "-"}</p>
                  </Col>
                ) : null}
                {grant?.floor ? (
                  <Col xs={12} md={6} lg={4} xxl={3}>
                    <Label
                      htmlFor={`recurringGrants[${index}].floor`}
                      className="fw-bold"
                    >
                      Floor
                    </Label>
                    <p>{grant?.floor ? grant?.floor : "-"}</p>
                  </Col>
                ) : null}
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label className="fw-bold">Prorate</Label>
                  <p>{grant?.prorate ? "Yes" : "No"}</p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label className="fw-bold">Override</Label>
                  <p>{grant?.override ? "Yes" : "No"}</p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label
                    for={`recurringGrants[${index}].validityStartsOn`}
                    className="fw-bold"
                  >
                    Validity Starts
                  </Label>
                  <p>
                    {grant?.validityStartsOn
                      ? grant?.validityStartsOn?.label
                      : "-"}
                  </p>
                </Col>
                <Col xs={12} md={6} lg={4} xxl={3}>
                  <Label
                    for={`recurringGrants[${index}].validityEndsOn`}
                    className="fw-bold"
                  >
                    Validity Ends
                  </Label>
                  <p>
                    {grant?.validityEndsOn ? grant?.validityEndsOn?.label : "-"}
                  </p>
                </Col>
                {grant?.validityEndsOn?.label === "Relative" && (
                  <Col xs={12} md={6} lg={4} xxl={3}>
                    <Label className="fw-bold">Time Period</Label>
                    <p>
                      {`${
                        grant?.grantValidityEndsOnTimeperiod
                          ? grant?.grantValidityEndsOnTimeperiod
                          : "-"
                      } ${
                        grant?.grantValidityEndsOn
                          ? grant?.grantValidityEndsOn?.label
                          : ""
                      }`}
                    </p>
                  </Col>
                )}
                <>
                  <Col xs={12} md={6} lg={4} xxl={3}>
                    <Label className="fw-bold">Rollover</Label>
                    <p>{grant?.rollover ? "Yes" : "No"}</p>
                  </Col>
                  {grant?.rollover ? (
                    <>
                      <Col xs={12} md={6} lg={4} xxl={3}>
                        <Label className="fw-bold">Rollover Priority</Label>
                        <p>
                          {grant?.rolloverModel?.rolloverPriority
                            ? "Yes"
                            : "No"}
                        </p>
                      </Col>
                      <Col xs={12} md={6} lg={4} xxl={3}>
                        <Label
                          htmlFor={`recurringGrants[${index}].rolloverModel.rolloverAmount`}
                          className="fw-bold"
                        >
                          Maximum Rollover Amount
                        </Label>
                        <p>
                          {grant?.rolloverModel
                            ? grant?.rolloverModel?.rolloverAmount
                            : "-"}
                        </p>
                      </Col>
                      <Col md={12} lg={4} className="me-2">
                        <Label
                          htmlFor={`recurringGrants[${index}].rolloverModel.rolloverCycle`}
                          className="fw-bold"
                        >
                          Maximum Rollover Cycle
                        </Label>
                        <p>
                          {grant?.rolloverModel
                            ? grant?.rolloverModel?.rolloverCycle
                            : "-"}
                        </p>
                      </Col>
                    </>
                  ) : null}
                </>
              </Row>
            </div>
          );
        })
      )}
    </CardBody>
  );
};

export default ViewOfferGrantsRecurring;
